import { Grid, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { useDevice } from "../../../providers/DeviceProvider";

const useStyles = makeStyles()(
  (theme) => ({
    card: {
      background: theme.palette.background.default,
      position: "relative",
      cursor: "pointer",
      overflow: "hidden",
      height: "100%",
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: "4px",
      boxSizing: "border-box",
      "& .img-container": {
        height: "132px",
        overflow: "hidden",
        position: "relative",
        borderTopLeftRadius: "4px",
        borderTopRightRadius: "4px",
        "& img": {
          borderTopLeftRadius: "4px",
          borderTopRightRadius: "4px",
          objectFit: "cover",
          height: "100%",
          width: "100%",
          transition: "transform 0.25s",
          verticalAlign: "baseline-middle"
        },
      },
      "@media (hover: hover)": {
        "&:hover": {
          "&:before": {
            background: theme.palette.action.hover,
            position: "absolute",
            height: "100%",
            width: "100%",
            content: "''",
            display: "block",
            zIndex: 30,
            pointerEvents: "none"
          },
          "& img": {
            transform: "scale(1.075)"
          }
        },
      }
    },
    isMobilePortraitView: {
      borderRadius: theme.spacing(2),
      boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.06)",
    },
    cardText: {
      padding: "12px 16px"
    },
    disabledCard: {
      filter: "grayscale(100%)",
      "& img": {
        transform: "scale(1) !important"
      },
      "&:before": {
        display: "none !important"
      }
    },

  })
);


export default function DynamicCard(props) {
  const { img, title, description, onClick, disabled } = props;
  const { classes } = useStyles();
  const { isMobilePortraitView } = useDevice();

  return (
    <div className={`${classes.card} ${isMobilePortraitView ? classes.isMobilePortraitView : ""} ${disabled ? classes.disabledCard : ""} ${props.className || ""}`} onClick={onClick}>
      <div className="img-container">
        <img src={img} alt="artistic rendering of variant" />
      </div>
      <Grid container direction="column" className={classes.cardText}>
        <Typography variant="subtitle1">
          {title}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {description}
        </Typography>
      </Grid>
    </div>
  );
}